import styled from 'styled-components/macro';

export const Container = styled.div`
  padding-top: 0.5rem;
  position: absolute;
  z-index: 1;

  .CBody {
    padding: 1rem;
  }
`;
